





















import { Component, Prop, Vue } from "vue-property-decorator";
import CzDone from "./CzDone.vue";

@Component({ components: { CzDone } })
export default class CzPlanRow extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, default: "" }) meta!: string;
  @Prop({ type: String, default: "" }) sub!: string;
  @Prop({ type: String, default: "" }) note!: string;
  @Prop({ type: [String, Object], default: "" }) to!: string | object;
  @Prop({ type: Boolean, default: false }) clickable!: boolean;
  @Prop({ type: Boolean, default: false }) done!: boolean;
  @Prop({ type: Boolean, default: false }) toggle!: boolean;
  @Prop({ type: Boolean, default: false }) locked!: boolean;
  @Prop({ type: Boolean, default: false }) accent!: boolean;
  @Prop({ type: String, default: "" }) doneLabel!: string;
  @Prop({ type: Boolean, default: false }) busy!: boolean;

  get textTag(): string {
    if (this.to) return "router-link";
    return this.clickable ? "button" : "div";
  }
}
